import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import KEYCODE from 'keycode'
import { withRouter } from 'react-router-dom'
import titleize from 'titleize'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import { parseLocation } from '../../../common/utils/urlHelper'
import FiltersMultiSelectPanel from './filtersPanel/multiSelect'
import { reportOpenSearchFilterPanel } from '../../../common/analytics/filtersAnalytics'
import VocalsIcon from '../icons/vocals'
import RightOpenIcon from '../icons/rightOpen'

class FiltersVocals extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Vocals')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  render() {
    const { showPanel } = this.state
    const { items, location, isAtTop } = this.props
    const parsedLocation = parseLocation(location)
    const chosenVocals = parsedLocation.vocals_in_audio || ''

    const renderChosenVocals = () => {
      if (chosenVocals === '') {
        return (
          <ul className="search-facet-listing">
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">
                      {titleize(item.key)}
                    </span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        return (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              <div className="search-facet-panel__status-title">
                {chosenVocals.split(',').join(', ')}
              </div>
            </div>
          </div>
        )
      }
    }

    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-panel__header': !isAtTop,
      'is-active': showPanel
    })

    return (
      <div className="search-facet--no-margin" id="vocals-filter">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <VocalsIcon /> Vocals
            <span style={{ float: 'right' }}>
              <RightOpenIcon />
            </span>
          </h2>
          {renderChosenVocals()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersMultiSelectPanel
                type="vocals_in_audio"
                showPanel={showPanel}
                items={items}
                parsedLocation={parsedLocation}
                togglePanel={this.togglePanel}
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersVocals.propTypes = {
  location: PropTypes.object.isRequired,
  items: PropTypes.array
}

export const FiltersVocalsComponent = FiltersVocals
export default withRouter(FiltersVocals)



// WEBPACK FOOTER //
// ./client/components/filters/filtersVocals.js